var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 8.74427V2.66675C15.3335 1.56218 14.4381 0.666748 13.3335 0.666748H2.66683C1.56226 0.666748 0.66683 1.56218 0.66683 2.66675V8.74427C0.66683 9.84884 1.56226 10.7443 2.66683 10.7443H4.66683C4.85092 10.7443 5.00016 10.8935 5.00016 11.0776V15.0078C5.00016 15.1356 5.15012 15.2044 5.24696 15.1211L10.0808 10.9617C10.2438 10.8214 10.4518 10.7443 10.6668 10.7443H13.3335C14.4381 10.7443 15.3335 9.84884 15.3335 8.74427Z",
    stroke: "#DD4242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrChat);
export default __webpack_public_path__ + "static/media/cr_chat.86c52b90.svg";
export { ForwardRef as ReactComponent };